import { render, staticRenderFns } from "./ScrollingText.vue?vue&type=template&id=1152584a&scoped=true"
import script from "./ScrollingText.vue?vue&type=script&lang=js"
export * from "./ScrollingText.vue?vue&type=script&lang=js"
import style0 from "./ScrollingText.vue?vue&type=style&index=0&id=1152584a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152584a",
  null
  
)

export default component.exports